import PolicyDetailPet from './PolicyDetailPet';
export default PolicyDetailPet;
